export class ResponseCodeConstant{
    public static INTERNAL_SERVER_ERROR = '0099';
}
